import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-paper pt-12 pb-8 border-t border-gray-200">
      <div className="max-w-6xl mx-auto px-6">
        
        {/* Important Disclaimer */}
        <div className="bg-gray-100 rounded-2xl p-6 mb-12 text-center">
          <p className="text-sm text-ink/60 font-medium leading-relaxed max-w-4xl mx-auto">
            <strong className="text-ink/80">Medical Disclaimer:</strong> Curve is not a medical device and does not provide medical advice, diagnosis, or treatment. It is a tracking tool designed to help you monitor your personal routine. Always consult your healthcare provider or physician regarding your medication, dosage, side effects, and overall health.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8">
          <Link to="/" className="flex items-center gap-3 text-2xl font-bold tracking-tighter text-ink">
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1781865268786-image.png" 
              alt="Curve Logo" 
              className="w-8 h-8 rounded-[10px] object-cover shadow-sm"
            />
            Curve
          </Link>
          
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-ink/60">
            <Link to="/privacy" className="hover:text-ink transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-ink transition-colors">Terms of Use</Link>
            <Link to="/disclaimer" className="hover:text-ink transition-colors">Medical Disclaimer</Link>
            <Link to="/contact" className="hover:text-ink transition-colors">Contact</Link>
          </div>
        </div>
        
        <div className="text-center text-sm text-ink/40 font-light border-t border-gray-200 pt-8">
          &copy; {new Date().getFullYear()} Sussex Endocrine Clinic. All rights reserved. Not affiliated with Novo Nordisk or Eli Lilly.
        </div>
      </div>
    </footer>
  );
};